<template>
	<BaseCenteredMessage hideLogoutButton class="bg-white">
		<template #icon><BaseIcon name="mono/error" class="w-40 h-40 text-red-500" /></template>
		<template #title><div class="text-gray-500">Authentication Error</div></template>
		<template #details>
			<p class="text-gray-500">
				{{ errorDescription }}
			</p>
		</template>
		<template #actions>
			<button class="button-green" @click="$auth.login">Sign up or login via BrowserStack</button>
		</template>
	</BaseCenteredMessage>
</template>

<script>
import {useTitle} from 'shared/composables/useTitle'

export default {
	name: 'AuthError',
	setup() {
		useTitle('Error')
	},
	computed: {
		errorDescription() {
			const error = this.$route.query.error_description
			if (error === 'signup.forbidden') {
				return 'Please signup using your BrowserStack account.'
			}
			if (error === 'user.not_found') {
				return 'Your user was not found. If you have an account, please contact customer support to resolve this issue, or sign up via BrowserStack.'
			}
			return 'An error occurred while authenticating. Please try again.'
		},
	},
	async mounted() {
		await this.$auth.logout({silent: true})
	},
}
</script>
